module.exports = __webpack_public_path__ + "assets/media/september.78110989.svg";